module.exports = __webpack_public_path__ + "static/media/Nayan_Chavan.23a0b3ee.png";